export const JOBS_STEPS = {
  JOB_INFO: 1,
  APPLICANT_INFO: 2,
  FINISH: 3,
};
